
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
import VeeMessages from 'vee-validate/dist/locale/ru';
import VeeValidate from 'vee-validate';

VeeValidate.Validator.localize('ru', VeeMessages);
VeeValidate.Validator.localize('ru', {
    ru: {
        messages: {
            confirmed: () => {
                return "Пароли не совпадают";
            }
        }
    }
});

const vee_config = {
    errorBagName: 'errors', // change if property conflicts.
    fieldsBagName: 'fields',
    delay: 0,
    locale: 'ru',
    dictionary: {
        ru: { messages: VeeMessages }
    },
    strict: true,
    enableAutoClasses: false,
    classNames: {
        touched: 'touched', // the control has been blurred
        untouched: 'untouched', // the control hasn't been blurred
        valid: 'valid', // model is valid
        invalid: 'invalid', // model is invalid
        pristine: 'pristine', // control has not been interacted with
        dirty: 'dirty' // control has been interacted with
    },
    events: 'input|blur',
    inject: true
};

Vue.use(VeeValidate, vee_config);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    data: {
        org_type: 0,
        name: ''
    },
    mounted() {
        // Keep external values after unsuccessfull validation (stored in data-initial tag)
        let _org_type = this.$refs.org_type.dataset.initial;
        let _name = this.$refs.username.dataset.initial;

        if (_org_type !== '') {
            this.org_type = _org_type;
        }
        if (_name !== '') {
            this.name = _name;
        }
        this.name = _name;
    },
    created() {
        this.$validator.extend('unique', {
            validate(value, args) {
                return axios.get('/register/validate/email/' + value).then((response) => {
                    return response.data.valid;
                });
            },
            /*
            messages: {
                ru: (field, args) => {
                    return 'Пользователь с таким '+field+' уже зарегистрирован в системе';
                }
            }
            */
            getMessage: function (field) {
                return 'Пользователь с таким '+field+' уже зарегистрирован в системе';
            }
        });
        this.$validator.extend('exists', {
            validate(value, args) {
                return axios.get('/register/validate/email/' + value).then((response) => {
                    return !response.data.valid;
                });
            },
            /*
            messages: {
                ru: (field, args) => {
                    return 'Пользователь с таким '+field+' не зарегистрирован в системе';
                }
            }
            */
            getMessage(field) {
                return 'Пользователь с таким '+field+' не зарегистрирован в системе';
            }
        });
        this.$validator.extend('phone', {
            validate(value, args) {
                return axios.get('/register/validate/phone/' + value).then((response) => {
                    return response.data.valid;
                });
            },
            /*
            messages: {
                ru: (field, args) => {
                    return 'Телефон должен иметь вид +71234567890 или 81234567890';
                }
            }
            */
            getMessage() {
                return 'Телефон должен иметь вид +71234567890 или 81234567890';
            }
        });
        this.$validator.localize('ru', {
            ru: {
                messages: {
                    confirmed: () => {
                        return "Пароли не совпадают";
                    }
                }
            }
        });
    },
    watch: {
        name: function (val) {
            if (this.org_type < 2) {
                $('#contact_name').val(val);
            }
            if (this.org_type < 1) {
                $('#org_name').val(val);
            }
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/register.js